/** @format */

const template = `
<div class="container-fluid" id="printable-plan">
  <div class="row">
    <div class="col-7">
      <h1 id="skip-link-target" tabindex="-1">{{$ctrl.name}}</h1>
    </div>
    <div class="col-5 hidden-print">
      <div class="float-end">
        <button
          ng-if="$ctrl.stateNameToGoBack"
          ui-sref="{{$ctrl.stateNameToGoBack}}($ctrl.stateParamsToGoBack)"
          class="btn btn-secondary btn-hollow btn-sm navigate-back">
          <sis-icon icon="chevron" [icon-class]="'flip-180'"></sis-icon>
          <span translate>SIS_COMPONENTS.PRINT_PLAN.BACK</span>
        </button>
        <button class="btn btn-primary btn-sm" ng-click="$ctrl.print()">
          <span translate>SIS_COMPONENTS.PRINT_PLAN.PRINT</span>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h3>{{$ctrl.userName}}</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group-mimic student-details">
        <h4 class="info-header" translate>SIS_COMPONENTS.PRINT_PLAN.STUDENT_NUMBER</h4>
        <p>{{$ctrl.studentNumber}}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h3 class="study-plan" translate>SIS_COMPONENTS.PRINT_PLAN.STUDY_PLAN</h3>
    </div>
  </div>
  <table class="table styled-table table-condensed">
    <thead>
      <tr>
        <th class="col-3"><!-- Name --></th>
        <th class="col-1" translate>SIS_COMPONENTS.PRINT_PLAN.PLANNED_CREDITS</th>
        <th class="col-2" translate>SIS_COMPONENTS.PRINT_PLAN.TIMING</th>
        <th class="col-1" translate>SIS_COMPONENTS.PRINT_PLAN.ATTAINED_CREDITS</th>
        <th class="col-1" translate>SIS_COMPONENTS.PRINT_PLAN.GRADE_AVERAGE</th>
        <th class="col-1" translate>SIS_COMPONENTS.PRINT_PLAN.GRADE</th>
        <th class="col-1" translate>SIS_COMPONENTS.PRINT_PLAN.ATTAINED_DATE</th>
        <th class="col-2" translate>SIS_COMPONENTS.PRINT_PLAN.VALIDATION_STATE</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-class="{ 'printable-row-bottom': $last}" ng-repeat="row in $ctrl.rows">
        <td class="col-3" ng-class="$ctrl.indent(row.indent)">
          <span>{{row.code}}</span>
          <span>{{row.name | localizedString}}</span>
        </td>
        <td class="col-1">
          <span>{{row.plannedCredits | range}}</span>
          <span ng-if="row.plannedCredits && !row.isGroupingModule"> / </span>
          <plan-range credits="row.targetCredits"></plan-range>
          <span ng-if="row.plannedCredits || row.targetCredits" translate>SIS_COMPONENTS.PRINT_PLAN.CREDITS</span>
        </td>
        <td class="col-2">
          <study-period ng-if="$ctrl.hasTiming(row.planned)" periods="row.planned"></study-period>
        </td>
        <td class="col-1">
          <span ng-if="row.isAttained" class="unit-course-grade-title">{{row.attainedCredits | range}}</span>
          <span ng-if="row.attainedCredits" translate>SIS_COMPONENTS.PRINT_PLAN.CREDITS</span>
        </td>
        <td class="col-1">
          <span ng-if="row.isAttained" class="unit-course-grade-title">{{row.gradeAverage}}</span>
        </td>
        <td class="col-1">
          <span ng-if="row.isAttained" class="unit-course-grade-title">{{row.grade | localizedString }}</span>
        </td>
        <td class="col-1">
          <span ng-if="row.isAttained" class="unit-course-grade-title">{{row.attainmentDate | localDateFormat}}</span>
        </td>
        <td class="col-2"><span ng-if="row.state">{{::'SIS_COMPONENTS.PLAN_STATE.'+row.state|translate}}</span> </td>
      </tr>
    </tbody>
  </table>
</div>
`;
export default template;
